import type { ReactNode } from "react";
import { Link, Redirect } from "wouter";
import { useFirebaseAuth } from "@/hooks/use-firebase-auth";
import { canAccessCertificateAdmin } from "@/lib/panel-switcher-access";
import { Button } from "@/components/ui/button";
import Layout from "@/components/layout/layout";

/** Certification authoring is an assigned role, independent of membership. */
export function CertificateAdminGuard({ children }: { children: ReactNode }) {
  const { user, isLoading } = useFirebaseAuth();
  if (isLoading) return null;
  if (!user) {
    const returnTo = `${window.location.pathname}${window.location.search}`;
    return <Redirect to={`/auth?returnTo=${encodeURIComponent(returnTo)}`} />;
  }
  if (canAccessCertificateAdmin(user)) return <>{children}</>;

  // Inside the site layout: on its own it was a bare black screen with no
  // menu, which read as a broken page.
  return (
    <Layout>
      <div className="mx-auto max-w-lg space-y-4 px-4 py-16 text-center" role="alert">
        <h1 className="text-2xl font-semibold">Instructor access required</h1>
        <p>An administrator must assign you the Instructor role to create and manage certification courses. Changing your membership plan does not grant this access.</p>
        <Link href="/dashboard"><Button>Back to dashboard</Button></Link>
      </div>
    </Layout>
  );
}
